<template>
  <span>
    <span class="point" :style="{color: color}">●</span>
    <span>{{scope.text}}</span>
  </span>
</template>

<script>
export default {
  props: {
    instance: Object, // 插槽实例
    scope: Object // text, row, index
  },
  data() {
    return {
      actionColorList: {
        0: '#40B7BE',
        1: '#C3C3C3',
        2: '#F5222D',
        3: '#2279D2'
        
      },
      userColor: {  // 用户管理的颜色
        0: '#40B7BE',
        1: '#C3C3C3'
      }
    }
  },
  computed: {
    color() {
      const { status, useStatus } = this.scope.scope
      if(useStatus) {
        return this.userColor[useStatus]
      }
      return this.actionColorList[status]
    }
  }
}
</script>
